import type { FaireProductEntity } from "../../entity_types/product";

export const p_sh3n679vmv: FaireProductEntity = {
  token: "p_sh3n679vmv",
  type: "product",
  name: "Kawai -  Cartoon Animal Plush Toys - Cozy & Cute",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/8aecc25300403176c8057a0b79de913b2ac383c8155516a99fb5d6d8c1e50b1b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/202af85a5f2a51258c3f273c33781359e39e0a0410d93cf65f6528b0264909e9.jpeg",
    "https://cdn.faire.com/fastly/8b3b63cf32213d9655486d79a00824198afe1d7dc891faa804d00f2fe1ce36e1.jpeg",
    "https://cdn.faire.com/fastly/e0965d0b08cda528c6cf496415513700f21e0bed20cbe076019aa1c5e7873a18.jpeg",
    "https://cdn.faire.com/fastly/eb3ad2710f3cebf605ef9436173b75562db21f1a0703fe19bcefa03f9c658265.jpeg",
    "https://cdn.faire.com/fastly/cd2b6c7b888391af3884cd8de51a11067f33b2ef88d34f5b67bd81164ba9fc79.jpeg",
    "https://cdn.faire.com/fastly/946caf595cd58dab5e137cae7ce01bcf048421ecc8714d95896a1162091cc61a.jpeg",
    "https://cdn.faire.com/fastly/cb8a39f8abdcb093b3baa79fe413ba3277ef2e254b14aa2ee9d7e02367b60475.jpeg",
    "https://cdn.faire.com/fastly/4e9253013f9f124834620c9fbeaf3677343c0ebd64a511811dc15fc1ae231a34.jpeg",
    "https://cdn.faire.com/fastly/fa33e6ac86bc3124620123371df1c6410a7c90a972a199d406ca8ea54480b057.jpeg",
    "https://cdn.faire.com/fastly/5089d2d75e3287b1d5e8e8b696daa4047f5f08491d3a8d79d76b16c12ea7a434.jpeg",
    "https://cdn.faire.com/fastly/7b6526b2b4da2c1c55ac78af74ee2695972191256d604c6cc0df1cb433f87b19.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Keep your cozy with these cute cartoon animal toys. They’re soft on skin, have bright and nice colors, and come in 6 styles like calf, chick, duckling, puppy, lamb and bear. Our products have UPC codes and are packed in ready-to-sell packaging, easy to display or use right away.\n\n• Soft, skin-friendly materials\n• 6 cartoon animal styles: calf, chick, duckling, puppy, lamb, bear\n• Bright and harmonious colors—attracts babies’ attention\n• Suitable for placing on beds, sofas and in cars\n• Sweet and cute design, fits baby’s daily use\n• Retail-ready and ideal for store displays\n\nSize: About 11.0 in tall (28cm)\n\nPerfect for: comfort, daily play, home decor\nPeople also consider: plush toys, cartoon animal baby toys, soft stuffed animals",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:44.810Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
